import { useEffect, useRef } from 'react';

import { FormatedStaymentLog } from '../../../types';
import { StaymentLogWrapper, Steps } from './styles';

type StaymentStatusProps = {
  selectedStatus: number;
  setSelectedStatus: (current: number) => void;
  statusList?: FormatedStaymentLog[];
};

export function StaymentStatus(props: StaymentStatusProps) {
  const { selectedStatus, setSelectedStatus, statusList } = props;

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const centerActiveElement = () => {
      const activeElement = document.getElementsByClassName(
        'ant-steps-item-active'
      )[0];
      const parentElement = containerRef.current;

      if (activeElement && parentElement) {
        const parentRect = parentElement.getBoundingClientRect();
        const activeRect = activeElement.getBoundingClientRect();

        const scrollLeft =
          activeRect.left +
          activeElement.clientWidth / 2 -
          parentRect.left -
          parentElement.clientWidth / 2;

        parentElement.scrollTo({
          left: parentElement.scrollLeft + scrollLeft,
          behavior: 'smooth',
        });
      }
    };

    centerActiveElement();

    // Use requestAnimationFrame for better timing with DOM updates
    const animationFrame = requestAnimationFrame(centerActiveElement);

    return () => cancelAnimationFrame(animationFrame);
  }, [selectedStatus, statusList]);

  function renderTitle(status: FormatedStaymentLog) {
    return (
      <div className="status-title-container">
        <span className="status-title">{status.name}</span>
        <span className="status-subtitle">#{status.key}</span>
      </div>
    );
  }
  return (
    <StaymentLogWrapper ref={containerRef} className="StaymentLogWrapper">
      <Steps
        size="small"
        current={selectedStatus}
        onChange={setSelectedStatus}
        progressDot
        style={{ marginBottom: '55px', paddingBottom: '10px' }}
      >
        {statusList?.map((status) => {
          return <Steps.Step key={status.key} title={renderTitle(status)} />;
        })}
      </Steps>
    </StaymentLogWrapper>
  );
}
